<template>
  <div
    style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; background-color: #10172A; padding: 24px 18px; margin: 0 -15px -1px -15px;"
  >
    <a style="font-size: 13px; text-decoration: none; color: white;" href="https://www.gtrsuite.com/">{{ $t('leadWeekly.footer.gtrSuite') }}</a>
    <div style="background-color: white; width: 7px; height: 7px; border-radius: 50%;" />
    <a style="font-size: 13px; text-decoration: none; color: white;" href="mailto:support@gtrsuite.com">{{ $t('leadWeekly.footer.help') }}</a>
  </div>
</template>

<script>
export default {
  name: 'LpeReportFooter',
}
</script>
